export default {
      id: "kp-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#kp",
      toString: function () {
        return this.url;
      }
    }